<template>
    <b-modal id="bid-message" :title="title" @ok="sendMessage" ref="messageModal">
        <div class="form-group inline-label">
            <label for="bid-message-textarea" class="label-bid-message">
                Message
                <span @click.prevent="addEmojiMessage('&#x1F6AD')" class="cursor-pointer">&#x1F6AD</span>
                <span @click.prevent="addEmojiMessage('&#x1F44D')" class="cursor-pointer">&#x1F44D</span>
                <span @click.prevent="addEmojiMessage('&#x1F44E')" class="cursor-pointer">&#x1F44E</span>
                <span @click.prevent="addEmojiMessage('&#x1F44C')" class="cursor-pointer">&#x1F44C</span>
                <span @click.prevent="addEmojiMessage('&#x1F645')" class="cursor-pointer">&#x1F645</span>
            </label>
            <textarea ref="message" id="bid-message-textarea" v-model="message"></textarea>
        </div>

        <template v-if="!$userIsDealer() && !rep_only">
            <b-form-checkbox v-model="withEmail" id="email_to_user" class="float-left"></b-form-checkbox>
            <b-form-group :label="emailCheckBoxLabel" label-for="email_to_user"></b-form-group>
            <ul class="preset-message-list">
                <li v-for="(msg, index) in default_messages">
                    <a href="#!" @click.prevent="addToMessage(index)" :class="msg.used ? 'used' : 'not-used'">{{msg.msg}}</a>
                </li>
            </ul>
        </template>

    </b-modal>

</template>
<script>
    import {handleHttpError} from '../../util/common'
    import {getLandedCost} from "../../util/bid_helper";

    export default {
        created(){
        },
        mounted(){
        },
        data() {
            return {
                default_messages:[
                    {msg: 'Your bid was successful!', used: false},
                    {msg: 'The vehicle was sold for:', used: false},
                    {msg: 'Do you want to cancel your bid?', used: false},
                    {msg: 'I have cancelled your bid!', used: false},
                ],
                user: {name: ''},
                withEmail: true,
                rep_only: false,
                message: null
            }
        },
        computed: {
            title(){
                if (this.rep_only) {
                    return 'Staff Message Only'
                }
                if (this.$userIsDealer()) {
                    return 'Send Message';
                }

                let msg = 'Message';
                if (this.user && this.user.name) {
                    msg += ' - '+ this.user.name;
                }
                return msg;
            },
            emailCheckBoxLabel(){
                let label = '';
                if (this.user && this.user.name) {
                    label = 'Also e-mail this message to ' + this.user.name;
                } else {
                    label = 'Also e-mail this message to bidder';
                }
                return label;
            },
        },
        methods: {
            openModal(bid, vehicle, msg = '', rep_only = false, withEmail = true){
                this.$refs.messageModal.show();
                this.message = msg;
                this.withEmail = withEmail;
                this.rep_only = rep_only;
                this.bid = bid;
                this.vehicle = vehicle;
                this.user = bid.user;
                setTimeout(()=>{
                    this.$refs.message.focus();
                }, 200);
            },
            addToMessage(index){
                this.default_messages[index].used = true;
                let message = this.default_messages[index].msg
                let current_position = this.$refs.message.selectionStart || this.$refs.message.textLength;
                let msg_start = this.message.substring(0,current_position);
                let msg_end = this.message.substring(current_position);
                this.message = msg_start + ' ' + message + ' ' + msg_end;
            },
            addEmojiMessage(emoji){
                let div = document.createElement('div');
                div.innerHTML = emoji;
                this.message += div.textContent
            },
            async sendMessage(){
                try {
                    let bid_id = this.bid.id;
                    let message = this.message;
                    let result = await this.$store.dispatch('userBids/addBidMessage', {bid_id, rep_only: this.rep_only, message,
                        with_email: this.withEmail});
                    if (result && result.message) {
                        this.$emit('changed', bid_id, result.bid_message, result);
                    }
                } catch (e) {
                    handleHttpError(e);
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/VehicleSingle/BidMessage.vue